'use strict';

import React, { Component } from 'react'

import Link  from '@Pure/Link'

import Config from '@Config/Catalog/show_product'

const pricing_types = Config.fields['pricing_type'].options || [];

const { moment } = window;

export default class ProductRow extends Component
{
	render ()
	{
		const { data, blank=true, fields, ...props } = this.props;

		moment.locale('fr');

		const blank_props = blank === true
		? { target: '_blank', rel: 'noopener noreferrer' }
		: { };

		const link =
		(
			<Link className="u-link-only" { ...blank_props }
				href={ '/gestion-du-catalogue/billets/' + data.id }>
				<span className="u-readers-only">
					Page du produit
				</span>
			</Link>
		);

		let output =
		(
			<div className="c-dashboard__row">

				<div className="c-dashboard__cell Product-name">

					<div className="c-dashboard__long-text">
						{ data.name }
					</div>

					{ link }

				</div>

				<div className="c-dashboard__cell Product-pricing_type">

					{
						pricing_types.find(opt => opt.value === data.pricing_type)
						?.label
					}

					{ link }

				</div>

				<div className="c-dashboard__cell Product-_artist_name">

					{ data._artist?.name }

					{ link }

				</div>

				<div className="c-dashboard__cell Product-_place_name">

					{ data._place?.name }

					{ link }

				</div>

			</div>
		);

		return output;
	}
}